import { conditionalServiceWorkerInstall } from './opus2/util/serviceWorkerRegistration';
import { initPerformanceMonitoring, monitorLongTasks } from './opus2/performance/performanceModule';
const runPerformance = false;
if(runPerformance) {
    monitorLongTasks();
    initPerformanceMonitoring();
}

conditionalServiceWorkerInstall();
export * from './opus2';
export * from './global';